import { Fab, CssBaseline, Hidden } from '@material-ui/core';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { ScrollTop } from 'components';
import React from 'react';
import AppRouter from 'routes/AppRouter';
import { AuthDialog } from '../authDialog';
import { useStyles } from './app.style';
import BottomNavbar from './bottom-navbar';
import { Footer } from './footer';
import { Header } from './header';

declare module 'react' {
    interface HTMLAttributes<T> {
        attribution?: string;
        page_id?: string;
    }
}
const App: React.FC = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className="fb-customerchat" attribution="page_inbox" page_id="1088338904699786"></div>
            <CssBaseline />
            <Hidden only={['xs']}>
                <Header />
            </Hidden>
            <Hidden smUp>
                <BottomNavbar />
            </Hidden>

            <div className={classes.wrapper}>
                <div className={classes.content}>
                    <div className={classes.main}>
                        <AppRouter />
                    </div>

                    <Footer />
                </div>
            </div>

            <AuthDialog />

            <ScrollTop>
                <Fab color="primary" size="medium" aria-label="scroll back to top">
                    <KeyboardArrowUpIcon style={{ fontSize: 36 }} />
                </Fab>
            </ScrollTop>
        </div>
    );
};

export default App;
